import app from './app';
import { ORDER_SERVICE_URL } from '../../libs/constants';

const getIndirectCustomerOrderList = (userId, requestData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        console.log('Search Config of Indirect Customer Order list API: ' + JSON.stringify(requestData));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getIndirectCustomerOrderList" } };
        const response = await api.post(ORDER_SERVICE_URL + '/list/' + userId, requestData, headerConfig);

        dispatch(app.setLoading(false));
        dispatch({ type: "SET_INDIRECT_CUSTOMER_ORDER_LIST", data: response.data });
    } catch (error) {
        console.log(error);
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const getIndirectCustomerOrderDetails = (userId, orderId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getOrderDetails" } };
        const response = await api.post(ORDER_SERVICE_URL + `/${userId}/` + orderId, {}, headerConfig);

        dispatch(app.setLoading(false));
        dispatch({ type: "SET_ORDER_DETAILS", data: response.data });
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const cancelOrder = (userId, orderId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "orderCancellation" } };
        await api.post(ORDER_SERVICE_URL + '/cancel/' + `${userId}/` + orderId, {}, headerConfig);

        dispatch(app.setLoading(false));
        dispatch(getIndirectCustomerOrderDetails(userId, orderId));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const uploadVendorAFReport = (userId, orderId, fileData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "uploadVendoeAFReport", 'content-type': 'multipart/form-data', } };
        const response = await api.post('/report/upload/' + userId + '/' + orderId, fileData, headerConfig);
        console.log('Response of Indirect Customer file upload : ' + JSON.stringify(response));

        dispatch(app.setLoading(false));
    } catch (error) {
        console.log(error);
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const updateOrdersInformation = (updatedOrdersData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getUpdatedOrdersData" } };
        await api.post(ORDER_SERVICE_URL + '/updateOrderStatus', updatedOrdersData, headerConfig);

        dispatch(app.setLoading(false));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const updateSpecificOrderData = (value, columnName, rowIndex) => {
    return {
        type: 'UPDATE_SPECIFIC_ORDER_DATA',
        value,
        columnName,
        rowIndex
    }
};

const indirectCustomerActions = {
    getIndirectCustomerOrderList,
    uploadVendorAFReport,
    getIndirectCustomerOrderDetails,
    cancelOrder,
    updateSpecificOrderData,
    updateOrdersInformation
}

export default indirectCustomerActions;